// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-metric {
  margin-top: 46px !important;
}

.video-about-card .info-content {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}
.video-about-card .status-column,
.video-about-card .info-content {
  padding: 0 16px;
}
.video-about-card .status-value {
  color: var(--gray_dark2);
  font-size: 16px;
  font-weight: 600;
}
.video-about-card .status-label {
  color: var(--gray_dark1);
  margin-bottom: 8px;
  font-size: 14px;
}
.video-about-card h3 {
  font-weight: 600;
}

@media screen and (max-width: 1279px) {
  .video-about-card .info-content {
    grid-template-columns: repeat(auto-fill, minmax(157px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MetricsCard/index.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEE;EACE,aAAA;EACA,cAAA;EACA,2DAAA;AACJ;AACE;;EAEE,eAAA;AACJ;AAEE;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,wBAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;;AAMA;EACE;IACE,4DAAA;EAHF;AACF","sourcesContent":[".live-metric {\n  margin-top: 46px !important;\n}\n.video-about-card {\n  .info-content {\n    display: grid;\n    grid-gap: 16px;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n  .status-column,\n  .info-content {\n    padding: 0 16px;\n  }\n\n  .status-value {\n    color: var(--gray_dark2);\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .status-label {\n    color: var(--gray_dark1);\n    margin-bottom: 8px;\n    font-size: 14px;\n  }\n\n  h3 {\n    font-weight: 600;\n  }\n}\n\n@media screen and (max-width: 1279px) {\n  .video-about-card .info-content {\n    grid-template-columns: repeat(auto-fill, minmax(157px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
